import axios from 'axios';
import { toast } from 'react-hot-toast';
import LocalStorage from '../utils/LocalStorage';
import { API_URL } from '../config';

export const BASE_URL = API_URL;

// Register once — registering inside every API() call stacks interceptors and can
// amplify retries / side-effects under remount storms.
axios.interceptors.response.use(
  (response) => response,
  function (error) {
    if (!error.response) {
      error.response = {
        data: 'net work error',
        status: 500,
      };
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      if (window.location.pathname !== '/freelancer/auth/login') {
        console.log('Unauthorised');
        toast.error('Your session has expired. Please login again.');
        LocalStorage.logout();
        setTimeout(() => {
          window.location.replace('/');
        }, 1000);
      }
      return Promise.reject(error);
    }

    if (error.response.status === 403) {
      if (window.location.pathname !== '/freelancer/auth/login') {
        console.log('Forbidden - Access denied or session expired');
        toast.error('Access denied. Your session may have expired. Please login again.');
        LocalStorage.logout();
        setTimeout(() => {
          window.location.replace('/');
        }, 1000);
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

const API = async (config: any) => {
  const token = LocalStorage.getApiKey();
  if (token) {
    if (config.contentType) {
      config.headers = {
        'Content-Type': config.contentType,
        Authorization: token,
      };
    } else {
      config.headers = {
        'Content-Type': 'application/json',
        Authorization: token,
      };
    }
  }
  config.baseURL = API_URL;
  config.withCredentials = true;
  return axios(config);
};

export default API;
